export const DITokens = {
  cradleService: "cradleService",
  // Values
  serverVersion: "serverVersion",
  appDefaultRole: "appDefaultRole",
  appDefaultRoleNoLogin: "appDefaultRoleNoLogin",
  typeormService: "typeormService",
  // Instances
  serverHost: "serverHost",
  exceptionFilter: "exceptionFilter",
  loggerFactory: "loggerFactory",
  httpClientFactory: "httpClientFactory",
  socketIoGateway: "socketIoGateway",
  multerService: "multerService",
  configService: "configService",
  taskManagerService: "taskManagerService",
  toadScheduler: "toadScheduler",
  eventEmitter2: "eventEmitter2",
  printerService: "printerService",
  printerTagService: "printerTagService",
  printerMaintenanceLogService: "printerMaintenanceLogService",
  floorPositionService: "floorPositionService",
  printJobService: "printJobService",
  printQueueService: "printQueueService",
  fileStorageService: "fileStorageService",
  fileAnalysisService: "fileAnalysisService",
  printFileDownloaderService: "printFileDownloaderService",
  floorService: "floorService",
  yamlService: "yamlService",
  settingsService: "settingsService",
  serverReleaseService: "serverReleaseService",
  monsterPiService: "monsterPiService",
  githubService: "githubService",
  octokitService: "octokitService",
  clientBundleService: "clientBundleService",
  logDumpService: "logDumpService",
  userTokenService: "userTokenService",
  authService: "authService",
  refreshTokenService: "refreshTokenService",
  apiKeyService: "apiKeyService",
  userService: "userService",
  userRoleService: "userRoleService",
  permissionService: "permissionService",
  jwtService: "jwtService",
  roleService: "roleService",
  prusaLinkApi: "prusaLinkApi",
  octoprintApi: "octoprintApi",
  octoprintClient: "octoprintClient",
  moonrakerApi: "moonrakerApi",
  moonrakerClient: "moonrakerClient",
  bambuApi: "bambuApi",
  bambuClient: "bambuClient",
  bambuFtpAdapter: "bambuFtpAdapter",
  bambuMqttAdapter: "bambuMqttAdapter",
  cameraStreamService: "cameraStreamService",
  socketFactory: "socketFactory",
  printerApiFactory: "printerApiFactory",
  printerLogin: "printerLogin",
  batchCallService: "batchCallService",
  influxDbV2BaseService: "influxDbV2BaseService",
  systemInfoBundleService: "systemInfoBundleService",
  // Stores
  floorStore: "floorStore",
  settingsStore: "settingsStore",
  printerSocketStore: "printerSocketStore",
  testPrinterSocketStore: "testPrinterSocketStore",
  prusaLinkPollingAdapter: "prusaLinkPollingAdapter",
  octoPrintSockIoAdapter: "octoPrintSockIoAdapter",
  moonrakerWebsocketAdapter: "moonrakerWebsocketAdapter",
  // Caches
  printerCache: "printerCache",
  printerEventsCache: "printerEventsCache",
  printerThumbnailCache: "printerThumbnailCache",
  fileUploadTrackerCache: "fileUploadTrackerCache",
  // Tasks
  bootTask: "bootTask",
  softwareUpdateTask: "softwareUpdateTask",
  clientDistDownloadTask: "clientDistDownloadTask",
  socketIoTask: "socketIoTask",
  printerWebsocketTask: "printerWebsocketTask",
  printerWebsocketRestoreTask: "printerWebsocketRestoreTask",
  printJobAnalysisTask: "printJobAnalysisTask",
} as const;
